'use client';

import { c as _c } from "react/compiler-runtime";
import { useLayoutEffect, useMemo } from 'react';
import { ApolloNextAppProvider } from '@apollo/client-integration-nextjs';
import useLogoutClient from 'data-hooks/useUserData/useLogoutClient';
import makeApolloClient from './makeApolloClient';

// The browser client is a singleton that outlives this provider, so it calls
// the logoutClient of the provider mounted now, not the one that created it
// (CON-8904). Until the first effect runs, it uses the creating one.
const latestLogoutClient = {
  current: null
};
const ApolloClientProvider = t0 => {
  const $ = _c(8);
  const {
    children
  } = t0;
  const logoutClient = useLogoutClient();
  let t1;
  let t2;
  if ($[0] !== logoutClient) {
    t1 = () => {
      latestLogoutClient.current = logoutClient;
    };
    t2 = [logoutClient];
    $[0] = logoutClient;
    $[1] = t1;
    $[2] = t2;
  } else {
    t1 = $[1];
    t2 = $[2];
  }
  useLayoutEffect(t1, t2);
  let t3;
  if ($[3] !== logoutClient) {
    t3 = () => {
      const client = makeApolloClient(() => (latestLogoutClient.current ?? logoutClient)({
        client
      }))();
      return client;
    };
    $[3] = logoutClient;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  const makeClient = t3;
  let t4;
  if ($[5] !== children || $[6] !== makeClient) {
    t4 = <ApolloNextAppProvider makeClient={makeClient}>{children}</ApolloNextAppProvider>;
    $[5] = children;
    $[6] = makeClient;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  return t4;
};
export default ApolloClientProvider;